module.exports = __webpack_public_path__ + "static/media/activity-import-template.f4823200.csv";